import {Checkbox} from '@wandb/weave/components/Checkbox';
import React from 'react';

import {FILE_KEY_DELIMITER, Property} from '../../utilTypes';
import PropertyHeader from './PropertyHeader';

type CheckboxEntryProps = {
  property: Property;
  value: boolean | undefined | null;
  onChange: (newValue: any) => void;
};

export const CheckboxEntry = ({
  property,
  value,
  onChange,
}: CheckboxEntryProps) => {
  const id = (property.file ?? '') + FILE_KEY_DELIMITER + property.key;

  const handleChange = (checked: boolean | 'indeterminate') => {
    const value = checked === 'indeterminate' ? null : checked;
    onChange({property: id, value});
  };

  const titleWithoutTrailingPunctuation = property.title?.replace(
    /[^\w\s]*$/,
    ''
  );

  return (
    <div
      className="m-0 flex flex-col text-sm"
      key={property.key}
      data-test="checkbox-entry">
      <PropertyHeader property={property} />
      <div className="flex items-center">
        <Checkbox
          size="small"
          id={id}
          checked={value ?? false}
          onCheckedChange={handleChange}
        />
        <label
          htmlFor={id}
          className="ml-8 text-sm text-moon-800 cursor-pointer">
          {titleWithoutTrailingPunctuation}
        </label>
      </div>
    </div>
  );
};
